<template>
  <div class="city-picker">
     
    <div :id="mapId" class="map-container"></div>
    <div class="address-info" v-if="selectedLocation" style="display: none;">
      <p class="address-title">详细地址：</p>
      <p class="address-content">{{ selectedLocation.address }}</p>
      <div class="address-details" v-if="selectedLocation.details" style="display: none;">
        <p>此点最近地点信息：{{ selectedLocation.details.address }}</p>
        <p>此点距离最近地点信息距离：{{ selectedLocation.details.address_distance }}米</p>
        <p>此点在最近地点信息方向：{{ selectedLocation.details.address_position }}</p>
        <p>此点所在国家或城市或区县：{{ selectedLocation.details.city }}</p>
        <p>距离此点最近poi点：{{ selectedLocation.details.poi }}</p>
        <p>距离此点最近poi点的距离：{{ selectedLocation.details.poi_distance }}米</p>
        <p>此点在最近poi点的方向：{{ selectedLocation.details.poi_position }}</p>
        <p>距离此点最近的路：{{ selectedLocation.details.road }}</p>
        <p>此点距离此路的距离：{{ selectedLocation.details.road_distance }}米</p>
      </div>
    </div>
    <div class="city-list" v-if="searchResults.length > 0">
      <div 
        v-for="city in searchResults" 
        :key="city.id"
        class="city-item"
        @click="selectCity(city)"
      >
        {{ city.name }}
      </div>
    </div>
  </div>
</template>

<script>
/* global T */
export default {
  name: 'CityPicker',
  props: {
    initialCity: {
      type: String,
      default: ''
    },
    mapId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      map: null,
      searchKeyword: '',
      searchResults: [],
      isMapLoaded: false,
      localSearch: null,
      geocoder: null,
      selectedLocation: null
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      // 检查是否已经加载过天地图
      if (window.T) {
        this.initMapInstance()
        return
      }

      // 动态加载天地图
      const script = document.createElement('script')
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=67e913d5125e9eb59f86b73b73f5e502`
      script.onload = () => {
        this.initMapInstance()
      }
      script.onerror = () => {
        console.error('Failed to load Tianditu')
        this.$message.error('地图加载失败，请刷新页面重试')
      }
      document.head.appendChild(script)
    },
    initMapInstance() {
      try {
        // 初始化地图
        this.map = new T.Map(this.mapId)
        // 设置地图中心点和缩放级别
        this.map.centerAndZoom(new T.LngLat(116.40969, 39.89945), 12)
        
        // 添加地图控件
        this.map.addControl(new T.Control.Zoom()) // 添加缩放控件
        this.map.addControl(new T.Control.MapType()) // 添加地图类型控件
        this.map.addControl(new T.Control.Scale()) // 添加比例尺控件

        // 启用滚轮缩放
        this.map.enableScrollWheelZoom()

        // 初始化地理编码器
        this.geocoder = new T.Geocoder()

        // 添加地图点击事件
        this.map.addEventListener('click', (e) => {
          this.handleMapClick(e.lnglat)
        })

        // 初始化本地查找
        this.localSearch = new T.LocalSearch(this.map, {
          onSearchComplete: (result) => {
            if (result && result.getCurrentNumPois() > 0) {
              const pois = []
              for (let i = 0; i < result.getCurrentNumPois(); i++) {
                const poi = result.getPoi(i)
                if (poi && poi.name) {
                  pois.push({
                    id: i,
                    name: poi.name,
                    location: poi.lnglat,
                    type: poi.type,
                    address: poi.address
                  })
                }
              }
              this.searchResults = pois
            } else {
              this.searchResults = []
            }
          }
        })

        this.isMapLoaded = true

        // 如果有初始城市，进行定位
        if (this.initialCity) {
          this.searchKeyword = this.initialCity
          this.handleSearch()
        }
      } catch (error) {
        console.error('Failed to initialize map:', error)
        this.$message.error('地图初始化失败，请刷新页面重试')
      }
    },
    handleSearch() {
      // if (!this.searchKeyword || !this.isMapLoaded) {
      //   this.searchResults = []
      //   return
      // }

      // // 设置查找参数
      // const options = {
      //   keyword: this.searchKeyword,
      //   pageCapacity: 10,
      //   pageIndex: 1,
      //   city: '全国',
      //   type: 'city'
      // }

      // this.localSearch.search(options)
    },
    selectCity(city) {
      this.$emit('select', {
        name: city.name,
        location: {
          lng: city.location.lng,
          lat: city.location.lat
        },
        type: city.type,
        address: city.address
      })
      this.searchResults = []
      this.searchKeyword = city.name
      
      // 移动地图到选中的城市
      if (this.map && city.location) {
        this.map.centerAndZoom(city.location, 11)
        
        // 清除之前的标记
        this.map.clearOverLays()
        
        // 添加标记
        const marker = new T.Marker(city.location)
        this.map.addOverLay(marker)
        
        // 添加信息窗口
        const infoWin = new T.InfoWindow(city.name)
        marker.addEventListener('click', () => {
          marker.openInfoWindow(infoWin)
        })
      }
    },
    handleMapClick(lnglat) {
      if (!this.geocoder) return

      this.geocoder.getLocation(lnglat, (result) => {
        if (result.getStatus() === 0) {
          const addressComponent = result.getAddressComponent()
          this.selectedLocation = {
            address: result.getAddress(),
            details: {
              address: addressComponent.address,
              address_distance: addressComponent.address_distance,
              address_position: addressComponent.address_position,
              city: addressComponent.city,
              poi: addressComponent.poi,
              poi_distance: addressComponent.poi_distance,
              poi_position: addressComponent.poi_position,
              road: addressComponent.road,
              road_distance: addressComponent.road_distance
            },
            location: lnglat
          }

          // 清除之前的标记
          this.map.clearOverLays()
          
          // 添加新标记
          const marker = new T.Marker(lnglat)
          this.map.addOverLay(marker)
          
          // 添加信息窗口
          const infoWin = new T.InfoWindow(result.getAddress())
          marker.addEventListener('click', () => {
            marker.openInfoWindow(infoWin)
          })

          console.log(addressComponent)
          console.log(result.getAddress())
          console.log(lnglat)
          // 触发选择事件，传递更详细的地址信息
          this.$emit('select', {
            component: addressComponent,
            address: result.getAddress(),
            location: lnglat
          })
        } else {
          this.$message.error('获取位置信息失败：' + result.getMsg())
        }
      })
    }
  }
}
</script>

<style scoped>
.city-picker {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.search-box {
  margin-bottom: 10px;
}

.search-box input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.map-container {
  width: 100%;
  height: 300px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.address-info {
  margin-top: 10px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 4px;
}

.address-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.address-content {
  margin-bottom: 10px;
}

.address-details {
  font-size: 12px;
  color: #666;
}

.address-details p {
  margin: 3px 0;
}

.city-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.city-item {
  padding: 8px 12px;
  cursor: pointer;
}

.city-item:hover {
  background-color: #f5f5f5;
}
</style> 